module.exports = __webpack_public_path__ + "static/media/nav5.d98b1fc3.svg";